import { formatDate } from "../../../../../../utils/date";
import {
  MileageHistoryWrapper,
  MileageHeader,
  MileageHistoryTable,
  MileageHistoryItemWrapper,
  MileagePageWrapper,
} from "../../../mileage/style";
import {
  DepositLogType,
  MemberDepositLogDto,
  PubMemberDto,
} from "../../../../../../api/member";
import { Title } from "../../../../../../styles/page";
import { getMemberDepositLog } from "../../../../../../api/member";
import { useEffect, useState } from "react";
import { depositRefund } from "../../../../../../api/pub-point";
import { exchangePoint } from "../../../../../../utils/number";
interface DepositLogProps {
  onClose: () => void;
  member: PubMemberDto | null;
}

const DepositLog = ({ onClose, member }: DepositLogProps) => {
  const size = 10;
  const [allList, setAllList] = useState<MemberDepositLogDto[]>([]);
  const [list, setList] = useState<MemberDepositLogDto[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    if (!member) return;
    getMemberDepositLog(member.memberId).then((res) => {
      setAllList(res.list);
      setTotalPage(Math.max(1, Math.ceil(res.list.length / size)));
      setList(res.list.slice((currentPage - 1) * size, currentPage * size));
    });
  }, [member]);

  const formatType = (type: DepositLogType) => {
    switch (type) {
      case DepositLogType.PAYMENT:
        return "지급";
      case DepositLogType.PAYMENT_CANCEL:
        return "지급 취소";
      default:
        return "";
    }
  };

  const onPageChange = async (nextPage: number) => {
    if (currentPage + nextPage <= 0) return;
    if (currentPage + nextPage > totalPage) return;
    setCurrentPage(currentPage + nextPage);
  };

  useEffect(() => {
    setList(allList.slice((currentPage - 1) * size, currentPage * size));
  }, [currentPage]);

  const handleDepositCancel = async (id: number) => {
    try {
      await depositRefund(id);
      alert("환불이 완료되었습니다.");
      onClose();
    } catch (error: any) {
      alert(error.message);
    }
  };

  return (
    <MileageHistoryWrapper>
      <MileageHeader>
        <Title size={20}>내역</Title>
        <div className="right">
          <div className="name">
            보유 포인트 <span>{exchangePoint(member?.point || 0)}E</span>
          </div>
          <img
            src="/image-web/solution/close.svg"
            alt="close"
            onClick={() => onClose()}
          />
        </div>
      </MileageHeader>
      <MileageHistoryTable>
        <div className="header">
          <div className="item">날짜</div>
          <div className="item">구분</div>
          <div className="item">지급 E</div>
          <div className="item">결제금액</div>
          <div className="back"></div>
        </div>
        <div className="body">
          {list.length === 0 ? (
            <div className="no-data">내역이 없습니다. </div>
          ) : (
            list.map((item, index) => (
              <MileageHistoryItemWrapper key={index}>
                <div className="item">{formatDate(item.createdAt)}</div>
                <div className="item">{formatType(item.type)}</div>
                <div className="item">{exchangePoint(item.totalPoint)}</div>
                <div className="item">
                  {item.paymentAmount.toLocaleString()}
                </div>
                <div
                  className="back"
                  onClick={() => {
                    if (item.type === DepositLogType.PAYMENT) {
                      handleDepositCancel(item.id);
                    }
                  }}
                >
                  {item.type === DepositLogType.PAYMENT && !item.isRefund
                    ? "환불"
                    : ""}
                </div>
              </MileageHistoryItemWrapper>
            ))
          )}
        </div>
      </MileageHistoryTable>
      <MileagePageWrapper>
        <img
          src="image-web/solution/page-left.png"
          alt="arrow"
          onClick={() => onPageChange(-1)}
        />
        <div className="page">
          {currentPage} / {totalPage}
        </div>
        <img
          src="image-web/solution/page-right.png"
          alt="arrow"
          onClick={() => onPageChange(1)}
        />
      </MileagePageWrapper>
    </MileageHistoryWrapper>
  );
};

export default DepositLog;
